var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRivalChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #25282d;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #9a0df9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,16h-6V4c0-2.21-1.79-4-4-4H4C1.79,0,0,1.79,0,4v26c0,2.21,1.79,4,4,4h2.59l7.71,7.71c.19.19.45.29.71.29.13,0,.26-.02.38-.08.37-.15.62-.52.62-.92v-7h8v4c0,2.21,1.79,4,4,4h14v5c0,.4.24.77.62.92.12.05.25.08.38.08.26,0,.52-.1.71-.29l5.71-5.71h2.59c2.21,0,4-1.79,4-4v-18c0-2.21-1.79-4-4-4ZM15,32c-.55,0-1,.45-1,1v5.59l-6.29-6.29c-.19-.19-.44-.29-.71-.29h-3c-1.1,0-2-.9-2-2V4c0-1.1.9-2,2-2h38c1.1,0,2,.9,2,2v26c0,1.1-.9,2-2,2H15ZM54,38c0,1.1-.9,2-2,2h-3c-.27,0-.52.11-.71.29l-4.29,4.29v-3.59c0-.55-.45-1-1-1h-15c-1.1,0-2-.9-2-2v-4h16c2.21,0,4-1.79,4-4v-12h6c1.1,0,2,.9,2,2v18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.29,10.37H11.29c-.55,0-1,.45-1,1s.45,1,1,1h24c.55,0,1-.45,1-1s-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.29,22.37H11.29c-.55,0-1,.45-1,1s.45,1,1,1h16c.55,0,1-.45,1-1s-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.29,16.37H11.29c-.55,0-1,.45-1,1s.45,1,1,1h24c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivalChatIcon);
export default __webpack_public_path__ + "static/media/rival-chat-icon.53124ee735c57bfb8f94c4777b9a2d2e.svg";
export { ForwardRef as ReactComponent };